import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL;

export default function SuperAdminLogin() {
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const [visible, setVisible]     = useState(false);
  const [focused, setFocused]     = useState(false);
  const navigate                  = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res  = await fetch(`${API}/superadmin/login`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || 'Acceso denegado.'); return; }
      localStorage.setItem('sa_token', data.token);
      navigate('/superadmin');
    } catch {
      setError('No se pudo conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=Syne:wght@700;800&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .sa-root {
          min-height: 100vh;
          background: #080c14;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'IBM Plex Mono', monospace;
          overflow: hidden;
          position: relative;
        }

        /* Grid de fondo */
        .sa-root::before {
          content: '';
          position: fixed;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,122,0,.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,122,0,.04) 1px, transparent 1px);
          background-size: 48px 48px;
          pointer-events: none;
        }

        /* Luz ambiental naranja arriba a la derecha */
        .sa-glow {
          position: fixed;
          top: -120px;
          right: -80px;
          width: 480px;
          height: 480px;
          background: radial-gradient(circle, rgba(255,122,0,.12) 0%, transparent 70%);
          pointer-events: none;
        }

        /* Luz azulada abajo a la izquierda */
        .sa-glow2 {
          position: fixed;
          bottom: -100px;
          left: -60px;
          width: 380px;
          height: 380px;
          background: radial-gradient(circle, rgba(30,90,200,.1) 0%, transparent 70%);
          pointer-events: none;
        }

        .sa-card {
          position: relative;
          width: 420px;
          padding: 48px 44px 44px;
          background: rgba(13, 19, 32, 0.92);
          border: 1px solid rgba(255,122,0,.18);
          border-radius: 2px;
          backdrop-filter: blur(12px);
          opacity: 0;
          transform: translateY(18px);
          transition: opacity .5s ease, transform .5s ease;
          box-shadow:
            0 0 0 1px rgba(255,122,0,.06),
            0 32px 80px rgba(0,0,0,.6),
            inset 0 1px 0 rgba(255,255,255,.04);
        }
        .sa-card.visible {
          opacity: 1;
          transform: translateY(0);
        }

        /* Línea superior naranja */
        .sa-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent, #FF7A00, transparent);
        }

        /* Esquina decorativa */
        .sa-corner {
          position: absolute;
          bottom: -1px;
          right: -1px;
          width: 32px;
          height: 32px;
          border-right: 2px solid #FF7A00;
          border-bottom: 2px solid #FF7A00;
          border-radius: 0 0 2px 0;
          opacity: .5;
        }

        .sa-eyebrow {
          font-size: 10px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #FF7A00;
          margin-bottom: 10px;
        }

        .sa-brand {
          font-family: 'Syne', sans-serif;
          font-size: 30px;
          font-weight: 800;
          color: #ffffff;
          letter-spacing: -0.5px;
          line-height: 1;
          margin-bottom: 6px;
        }

        .sa-brand span {
          color: #FF7A00;
        }

        .sa-subtitle {
          font-size: 11px;
          color: #9aaac4;
          letter-spacing: 1px;
          margin-bottom: 40px;
          padding-bottom: 28px;
          border-bottom: 1px solid rgba(255,122,0,.12);
        }

        .sa-label {
          display: block;
          font-size: 10px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #a0b0cc;
          margin-bottom: 10px;
        }

        .sa-input-wrap {
          position: relative;
          margin-bottom: 28px;
        }

        .sa-input {
          width: 100%;
          background: rgba(255,255,255,.05);
          border: 1px solid rgba(255,255,255,.15);
          border-radius: 2px;
          padding: 14px 16px;
          font-family: 'IBM Plex Mono', monospace;
          font-size: 14px;
          color: #ffffff;
          outline: none;
          transition: border-color .2s, box-shadow .2s, background .2s;
          letter-spacing: 2px;
        }
        .sa-input::placeholder { color: #4a607a; letter-spacing: 1px; }
        .sa-input.focused {
          border-color: rgba(255,122,0,.4);
          background: rgba(255,122,0,.03);
          box-shadow: 0 0 0 3px rgba(255,122,0,.06), inset 0 1px 0 rgba(255,122,0,.05);
        }


        .sa-error {
          background: rgba(220, 38, 38, .08);
          border: 1px solid rgba(220,38,38,.2);
          border-left: 3px solid #dc2626;
          border-radius: 2px;
          padding: 10px 14px;
          font-size: 11px;
          color: #f87171;
          margin-bottom: 20px;
          letter-spacing: .5px;
        }
        .sa-error::before { content: '⚠ '; }

        .sa-btn {
          width: 100%;
          padding: 14px;
          background: #FF7A00;
          color: #1a0e00;
          border: none;
          border-radius: 2px;
          font-family: 'IBM Plex Mono', monospace;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: background .2s, transform .1s;
        }
        .sa-btn:hover:not(:disabled) { background: #ff8f20; }
        .sa-btn:active:not(:disabled) { transform: scale(.99); }
        .sa-btn:disabled { opacity: .5; cursor: not-allowed; }

        /* Shimmer en el botón */
        .sa-btn::after {
          content: '';
          position: absolute;
          top: 0; left: -100%;
          width: 60%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.15), transparent);
          transition: left .4s;
        }
        .sa-btn:hover:not(:disabled)::after { left: 150%; }

        .sa-footer {
          margin-top: 28px;
          font-size: 10px;
          color: #6a7f9a;
          letter-spacing: 1px;
          text-align: center;
        }

        .sa-dots {
          display: flex;
          gap: 6px;
          align-items: center;
          margin-bottom: 32px;
        }
        .sa-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #2a3a5a;
        }
        .sa-dot.active { background: #FF7A00; }
        .sa-dot.mid { background: #4a607a; }
      `}</style>

      <div className="sa-root">
        <div className="sa-glow" />
        <div className="sa-glow2" />

        <div className={`sa-card ${visible ? 'visible' : ''}`}>
          <div className="sa-corner" />

          <div className="sa-brand">TURN<span>ORA</span></div>
          <div className="sa-subtitle">PANEL DE FACTURACIÓN</div>

          <div className="sa-dots">
            <div className="sa-dot active" />
            <div className="sa-dot mid" />
            <div className="sa-dot" />
          </div>

          {error && <div className="sa-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <label className="sa-label">Clave de acceso</label>
            <div className="sa-input-wrap">
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder="••••••••••••"
                className={`sa-input ${focused ? 'focused' : ''}`}
                autoFocus
              />
            </div>

            <button type="submit" className="sa-btn" disabled={loading}>
              {loading ? 'VERIFICANDO...' : 'ACCEDER AL SISTEMA'}
            </button>
          </form>

          <div className="sa-footer">
            ACCESO AUTORIZADO
          </div>
        </div>
      </div>
    </>
  );
}
